module.exports = __webpack_public_path__ + "img/lajifenlei.bf4aec9d.png";